import _Promise from "babel-runtime/core-js/promise";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";


import * as utils from "@/tools/util";
import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import tools from "../../QS420/QS420_tools";

import oppService from "@/service/opp-service";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";
var SAVE_PATH3 = "";

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  fields.PRO_MANAGER_NAME.VALID_TYPE = "length[0,64]|on-blur";
  fields.PRO_MANAGER_NAME.FIELD_FUNCTION = "CHECK_PRO_MANAGER_NAME";
  fields.ID_ADDR.VALID_TYPE = "valAX[16,128]|on-blur";
  fields.BUSINESS_RANGE.VALID_TYPE = "length[0,2000]|on-blur|textarea";
  fields.BUSINESS_RANGE.isLongItem = true;
  fields.ID_CODE.VALID_TYPE = "length[0,48]|on-blur";
  fields.ID_CODE.FIELD_FUNCTION = fields.ID_CODE.FIELD_FUNCTION.replace(/\|GET_ZZ_DATA/g, "") + "|GET_ZZ_DATA";
  var idTypeDict = fields.ID_TYPE.FIELD_DICT_NAME;
  idTypeDict = _.filter(idTypeDict, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "1";
  });
  fields.ID_TYPE.FIELD_DICT_NAME = idTypeDict;
  if (_this.oppBusiData.hasAppvTask1) {
    fields.PRO_MANAGER_NAME.FIELD_CONTROL = "2";
    fields.ID_TYPE.FIELD_CONTROL = "2";
    fields.ID_CODE.FIELD_CONTROL = "2";
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var managerInfo = _Object$assign({}, _.get(_this.historyData, "BIZ_DATA.MANAGER_INFO", {}), _.get(_this.historyData, "BIZ_DATA.BASE_INFO", {}), _.get(_this.historyData, "BIZ_DATA.EXT_INFO", {}));
  managerInfo.ID_TYPE = managerInfo.PRO_MANAGER_ID_TYPE;
  managerInfo.ID_TYPE_DATA_SOURCE = managerInfo.PRO_MANAGER_ID_TYPE_DATA_SOURCE;
  managerInfo.ID_CODE = managerInfo.PRO_MANAGER_ID_CODE;
  managerInfo.ID_CODE_DATA_SOURCE = managerInfo.PRO_MANAGER_ID_CODE_DATA_SOURCE;
  managerInfo.ID_EXP_DATE = managerInfo.PRO_MANAGER_ID_EXP_DATE;
  managerInfo.ID_EXP_DATE_DATA_SOURCE = managerInfo.PRO_MANAGER_ID_EXP_DATE_DATA_SOURCE;
  _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], managerInfo);
  _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], managerInfo);
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
    SAVE_PATH3 = params.savePath3;
  },

  beforeLoadBiz: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this) {
      var _this2 = this;

      var customerInfo, CUST_CLS;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO);
              _context.next = 3;
              return oppService.getBusiCommonParamsFromCacheObjs("CUST_CLS");

            case 3:
              CUST_CLS = _context.sent;
              return _context.abrupt("return", _this.$syscfg.K_Request("F0000019", {
                ORG_CODE: customerInfo.INT_ORG,
                USER_TYPE: _this.$store.state.openAcctType == "3" ? "2" : "1"
              }).then(function (res) {
                var OPENTMPL_INFO = _.get(res, "Data[0]", {});
                if (!OPENTMPL_INFO.CUST_CLS) {
                  _this2.alert("客户模板中客户分类字段缺失！");
                  return;
                }
                if (!OPENTMPL_INFO.CHANNELS) {
                  _this2.alert("客户模板中操作渠道字段缺失！");
                  return;
                }
                if (!OPENTMPL_INFO.CUACCT_CLS) {
                  _this2.alert("客户模板中资金类别字段缺失！");
                  return;
                }
                if (!OPENTMPL_INFO.CUACCT_LVL) {
                  _this2.alert("客户模板中资产级别字段缺失！");
                  return;
                }
                if (!OPENTMPL_INFO.CUACCT_GRP) {
                  _this2.alert("客户模板中资产组别字段缺失！");
                  return;
                }
                if (!OPENTMPL_INFO.CUACCT_ATTR) {
                  _this2.alert("客户模板中资产属性字段缺失！");
                  return;
                }
                if (!!CUST_CLS) {
                  OPENTMPL_INFO.OLD_CUST_CLS = OPENTMPL_INFO.OLD_CUST_CLS || OPENTMPL_INFO.CUST_CLS;
                  OPENTMPL_INFO.CUST_CLS = CUST_CLS;
                  consoleLog("获取了业务公参的客户分类", CUST_CLS);
                }
                _this.oppBusiData.OPENTMPL_INFO = OPENTMPL_INFO;
                initFieldConfig(_this);
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeLoadBiz(_x2) {
      return _ref.apply(this, arguments);
    }

    return beforeLoadBiz;
  }(),

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this, params) {
      var orgImpInfo, managerInfo, baseInfo, extInfo, customerInfo;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              orgImpInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2, SAVE_PATH3]);
              managerInfo = {
                PRO_MANAGER_NAME: orgImpInfo.PRO_MANAGER_NAME,
                PRO_MANAGER_NAME_DATA_SOURCE: orgImpInfo.PRO_MANAGER_NAME_DATA_SOURCE,
                PRO_MANAGER_ENNAME: _.get(_this.oppBusiData, "hideFields.PRO_MANAGER_ENNAME.value", ""),
                PRO_MANAGER_ENNAME_DATA_SOURCE: _.get(_this.oppBusiData, "hideFields.PRO_MANAGER_ENNAME.DATA_SOURCE", ""),
                PRO_MANAGER_ID_TYPE: orgImpInfo.ID_TYPE,
                PRO_MANAGER_ID_TYPE_DATA_SOURCE: orgImpInfo.ID_TYPE_DATA_SOURCE,
                PRO_MANAGER_ID_CODE: orgImpInfo.ID_CODE,
                PRO_MANAGER_ID_CODE_DATA_SOURCE: orgImpInfo.ID_CODE_DATA_SOURCE,
                PRO_MANAGER_ID_EXP_DATE: orgImpInfo.ID_EXP_DATE,
                PRO_MANAGER_ID_EXP_DATE_DATA_SOURCE: orgImpInfo.ID_EXP_DATE_DATA_SOURCE,
                ID_BEG_DATE: orgImpInfo.ID_BEG_DATE,
                ID_BEG_DATE_DATA_SOURCE: orgImpInfo.ID_BEG_DATE_DATA_SOURCE
              };
              baseInfo = {
                ID_ADDR: orgImpInfo.ID_ADDR,
                ID_ADDR_DATA_SOURCE: orgImpInfo.ID_ADDR_DATA_SOURCE,
                INOUTSIDE_IDENTITY: orgImpInfo.ID_TYPE != "14" ? "0" : "1",
                OPEN_SOURCE: "2",
                ORG_ID_CODE: _this.oppBusiData.hideFields.ORG_ID_CODE && _this.oppBusiData.hideFields.ORG_ID_CODE.value || "",
                ORG_ID_EXP_DATE: orgImpInfo.ID_EXP_DATE,
                ORG_ID_EXP_DATE_DATA_SOURCE: orgImpInfo.ID_EXP_DATE_DATA_SOURCE,
                ID_EXP_DATE: orgImpInfo.ID_EXP_DATE,
                TAX_NO_EXP_DATE: orgImpInfo.ID_EXP_DATE,
                LAND_TAX_NO_EXP_DATE: orgImpInfo.ID_EXP_DATE,
                TAX_NO_EXP_DATE_DATA_SOURCE: orgImpInfo.ID_EXP_DATE_DATA_SOURCE,
                BUSINESS_TAX_NO: orgImpInfo.ID_CODE,
                BUSINESS_TAX_NO_DATA_SOURCE: orgImpInfo.ID_CODE_DATA_SOURCE,
                LAND_TAX_NO: orgImpInfo.ID_CODE,
                LAND_TAX_NO_DATA_SOURCE: orgImpInfo.ID_CODE_DATA_SOURCE,
                LAND_TAX_NO_EXP_DATE_DATA_SOURCE: orgImpInfo.ID_EXP_DATE_DATA_SOURCE,
                ID_ADDR2: orgImpInfo.ID_ADDR,
                IS_GROUP_TYPE: "0"
              };


              if (["14", "19", "1Z"].indexOf(orgImpInfo.ID_TYPE) > -1) {
                baseInfo.IS_GROUP_TYPE = "0";
                baseInfo.BUSINESS_TAX_NO = "";
                baseInfo.LAND_TAX_NO = "";
                baseInfo.TAX_NO_EXP_DATE = "";
                baseInfo.LAND_TAX_NO_EXP_DATE = "";
                baseInfo.ORG_ID_EXP_DATE = "";
                baseInfo.ORG_ID_CODE = "";
              } else {
                if ([18, 24].indexOf(orgImpInfo.ID_CODE.length) > -1) {
                  baseInfo.BUSINESS_TAX_NO = orgImpInfo.ID_CODE;
                  baseInfo.LAND_TAX_NO = orgImpInfo.ID_CODE;
                  baseInfo.ORG_ID_EXP_DATE = orgImpInfo.LAND_TAX_NO_EXP_DATE = orgImpInfo.TAX_NO_EXP_DATE = orgImpInfo.ID_EXP_DATE;
                  baseInfo.ORG_ID_CODE = orgImpInfo.ID_CODE.length === 24 ? orgImpInfo.ID_CODE.substring(14, 22) + "-" + orgImpInfo.ID_CODE.substring(22, 23) : orgImpInfo.ID_CODE.substring(8, 16) + "-" + orgImpInfo.ID_CODE.substring(16, 17);
                  baseInfo.IS_GROUP_TYPE = "1";
                } else {
                  baseInfo.IS_GROUP_TYPE = "0";
                  baseInfo.BUSINESS_TAX_NO = "";
                  baseInfo.LAND_TAX_NO = "";
                  baseInfo.TAX_NO_EXP_DATE = "";
                  baseInfo.LAND_TAX_NO_EXP_DATE = "";
                  baseInfo.ORG_ID_EXP_DATE = "";
                  baseInfo.ORG_ID_CODE = "";
                }
              }

              extInfo = {
                BUSINESS_RANGE: orgImpInfo.BUSINESS_RANGE,
                BUSINESS_RANGE_DATA_SOURCE: orgImpInfo.BUSINESS_RANGE_DATA_SOURCE
              };


              if (!params.BIZ_DATA) {
                params.BIZ_DATA = {};
              }
              if (!params.DETAIL_DATA) {
                params.DETAIL_DATA = {};
              }
              params.DETAIL_DATA.COMPANY_BASIC_INFO = _this.oppBusiData.companyBasicInfo;
              customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO) || {};

              _Object$assign(customerInfo, {
                USER_TYPE: "2"
              });
              _this.$store.commit(_this.$types.UPDATE_CUSTOMER_INFO, customerInfo);
              if (!_.isEmpty(_this.oppBusiData.OPENTMPL_INFO)) {
                _.set(params, "BIZ_DATA.OPENTMPL_INFO", _this.oppBusiData.OPENTMPL_INFO || {});
              }

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], managerInfo);
              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH2], baseInfo);
              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH3], extInfo);

              _.set(params, SAVE_PATH, _Object$assign({}, _.get(params, SAVE_PATH, {}), managerInfo));

              _.set(params, SAVE_PATH2, _Object$assign({}, _.get(params, SAVE_PATH2, {}), baseInfo));

              _.set(params, SAVE_PATH3, _Object$assign({}, _.get(params, SAVE_PATH3, {}), extInfo));

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function beforeSave(_x3, _x4) {
      return _ref2.apply(this, arguments);
    }

    return beforeSave;
  }(),
  validate: function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(_this) {
      var orgImpInfo, busiCode, params, bsno, res;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              orgImpInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2, SAVE_PATH3]);
              busiCode = this.$storage.getJsonSession(this.$definecfg.BUSI_DEF_INFO).BUSI_CODE;
              params = {
                ORG_CODE: _this.$storage.getSession(_this.$definecfg.F_CUST_ORG_CODE),
                ID_TYPE: orgImpInfo.ID_TYPE,
                ID_CODE: orgImpInfo.ID_CODE,
                BUSI_CODE: _this.busiCode
              };
              bsno = this.$storage.getSession(this.$definecfg.B_SNO);

              if (!(busiCode != "QS421")) {
                _context3.next = 8;
                break;
              }

              if (bsno) {
                _context3.next = 8;
                break;
              }

              _this.$store.commit(_this.$types.UPDATE_LOADING, true);
              return _context3.abrupt("return", this.$syscfg.K_Request("F0000036", params).then(function (res) {
                if (res.Code == 0) {
                  var dataList = res.Data.filter(function (bdata) {
                    return ["13", "15"].indexOf(bdata.PROC_STATUS) == -1;
                  });
                  _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                }
              }));

            case 8:
              if (!(params.ID_TYPE == "10")) {
                _context3.next = 16;
                break;
              }

              _this.$store.commit(_this.$types.UPDATE_LOADING, "正在进行营业执照核查");
              _context3.next = 12;
              return _this.$syscfg.K_Request("F0000060", { scCode: params.ID_CODE });

            case 12:
              res = _context3.sent;

              if (!(res.Code == 0)) {
                _context3.next = 16;
                break;
              }

              if (!(res.Data[0].flag == "0")) {
                _context3.next = 16;
                break;
              }

              return _context3.abrupt("return", new _Promise(function (resolve, reject) {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                _this.confirm({
                  messageText: "\u60A8\u5F55\u5165\u7684\u7EDF\u4E00\u793E\u4F1A\u4FE1\u7528\u4EE3\u7801\u201C" + params.ID_CODE + "\u201D\u4E0D\u7B26\u5408\u5176\u6821\u9A8C\u89C4\u5219\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u6B63\u786E\u3002",
                  cancelButtonText: "修改",
                  confirmButtonText: "确定",
                  confirmedAction: function confirmedAction() {
                    resolve(true);
                  },
                  canceledAction: function canceledAction() {
                    resolve(false);
                  }
                });
              }).then(function (res) {
                return res;
              }));

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function validate(_x5) {
      return _ref3.apply(this, arguments);
    }

    return validate;
  }(),
  pageActivated: function pageActivated(_this) {},
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {}
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS421/bizPro/bizManagerImportantInfo.js
// module id = 209
// module chunks = 2